import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import _ from 'lodash';

export const RANGE_TIME_PICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RangeTimePickerComponent),
  multi: true,
};

@Component({
  selector: 'host-range-time-picker',
  templateUrl: './range-time-picker.component.html',
  styleUrls: ['./range-time-picker.component.scss'],
  providers: [RANGE_TIME_PICKER_VALUE_ACCESSOR],
})
export class RangeTimePickerComponent implements OnInit, ControlValueAccessor {
  _value;
  @Input()
  get value() {
    return this._value;
  }
  set value(data: Date[]) {
    // 支持设置默认值。不过目前使用地方不多，使用最多的是重置为空
    this._value = data;
    if (data) {
      this.timeStart = data[0];
      this.timeEnd = data[1];
      this.sliderValue = [this.convertFromDate(this.timeStart), this.convertFromDate(this.timeEnd)];
    } else {
      this.timeStart = null;
      this.timeEnd = null;
      this.sliderValue = [this.min, this.max];
      this.textView = this.getTextView();
      // this.timeStart = null;
      // this.timeEnd = null;
      // this.sliderValue = [ this.min, this.max ];
    }
  }

  @Output() onSelect = new EventEmitter<any>();

  readonly min = 0;
  readonly max = 24 * 60 - 1;

  timeStart: Date = null;
  timeEnd: Date = null;
  sliderValue = [this.min, this.max];

  textView = '';

  visible = false;

  tipFormatter = (value) => {
    const hour = _.padStart(`${(value / 60) | 0}`, 2, '0');
    const minute = _.padStart(`${value % 60}`, 2, '0');
    return `${hour}:${minute}`;
  };
  _registerOnChange: (value: any) => void = (r: any) => {};

  constructor() {}

  ngOnInit() {}

  writeValue(data: Date[]): void {
    this._value = data;
    if (data) {
      this.timeStart = data[0];
      this.timeEnd = data[1];
      this.sliderValue = [this.convertFromDate(this.timeStart), this.convertFromDate(this.timeEnd)];
    } else {
      this.timeStart = null;
      this.timeEnd = null;
      this.sliderValue = [this.min, this.max];
      this.textView = this.getTextView();
    }
  }

  private convertToDate(value: number): Date {
    if (!value) {
      return null;
    }

    // const hour = _.padStart(`${(value / 60) | 0}`, 2, "0");
    // const minute = _.padStart(`${value % 60}`, 2, "0");

    const date = new Date(); // 日期默认会被废弃，只需要时间，所以这里日期随便设置
    date.setHours((value / 60) | 0);
    date.setMinutes(value % 60);
    return date;
  }

  private convertFromDate(date: Date) {
    if (!date) {
      return null;
    }

    const hour = date.getHours();
    const minute = date.getMinutes();

    return hour * 60 + minute;
  }

  private getTextView() {
    if (!this.timeStart && !this.timeEnd) {
      return '';
    }

    const start = this.tipFormatter(this.sliderValue[0]);
    const end = this.tipFormatter(this.sliderValue[1]);
    return `${start}~${end}`;
  }

  onTimeChange() {
    this.sliderValue = [this.convertFromDate(this.timeStart), this.convertFromDate(this.timeEnd)];
  }

  onSliderChange(value: number) {
    this.timeStart = this.convertToDate(value[0]);
    this.timeEnd = this.convertToDate(value[1]);
  }

  onConfirm() {
    this.onSelect.emit([this.timeStart, this.timeEnd]); // @deprecated
    this._registerOnChange([this.timeStart, this.timeEnd]);
    this.textView = this.getTextView();

    this.close();
  }

  onReset() {
    this.timeStart = null;
    this.timeEnd = null;
    this.sliderValue = [this.min, this.max];
    this.onSelect.emit(null); // @deprecated
    this._registerOnChange(null);
    this.textView = this.getTextView();

    this.close();
  }

  private close() {
    this.visible = false;
  }

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}
}
